import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  WebsiteAndAppDevelopmentIcon,
  cloudAndDevops,
  cyberSecurity,
  itSupportAndMaintainance,
  mobileAndAppDevelopment,
} from "../../../../assets/icons/serviceIcon/index";
import { useEffect } from "react";

const items = [
  {
    name: "Custom Software Development",
    text: "Your business has its own way of working, and your software should too. We create custom solutions that simplify operations, save time, and help you scale without the stress.",
  },
  {
    name: "SaaS Development",
    text: "Got a game-changing SaaS idea? We bring it to life with a scalable, high-performing platform that keeps customers engaged and your business growing.",
  },
  {
    name: "API Development & Integration",
    text: "Your systems should work together, not against you. We build and integrate APIs that connect your tools seamlessly, so your workflows stay smooth and hassle-free.",
  },
];

const otherService = [
  {
    icon: mobileAndAppDevelopment,
    name: "Mobile App Development",
    des: "We build apps that feel smooth, look great, and keep your users hooked.",
    path: "/mobile-app-development",
  },
  {
    icon: cloudAndDevops,
    name: "Cloud & DevOps Solutions",
    des: "No tech headaches - just fast, secure, and hassle-free cloud solutions.",
    path: "/cloud-devops-development",
  },
  {
    icon: WebsiteAndAppDevelopmentIcon,
    name: "Website & App Development",
    des: "We build websites that tell stories, connect hearts and build brands.",
    path: "/web-app-development",
  },
  {
    icon: cyberSecurity,
    name: "Cybersecurity & Data Protection",
    des: "Your data stays yours! We lock it down so hackers don’t stand a chance.",
    path: "/cybersecurity-data-protection",
  },
  {
    icon: itSupportAndMaintainance,
    name: "IT Support & Maintenance",
    des: "Seamless IT services to protect and power your business growth.",
    path: "/it-support-maintenance",
  },
];

const SoftwareAndSaasDevelopment = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "SaaS & Software Development Services | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "End-to-end SaaS and software development services to build scalable, secure, and high-performance digital products.",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute("content", "SaaS & Software Development Services");
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute(
      "href",
      "https://www.techqilla.com/software-saas-development",
    );
  }, []);

  return (
    <div>
      <NewCommonServiceHero
        heading="Software & Saas"
        colorHeading="Develpoment"
        description="Great software should feel effortless and built just for you. We build solutions that fit your business perfectly, making everything run smoother, faster, and without the usual tech frustrations."
      />
      <NewCommonServiceForm title="Software & Saas Development" items={items} />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default SoftwareAndSaasDevelopment;
